import {Component, Input, OnInit} from '@angular/core';
import {ExgEventArgs} from '../../misc/classes/ExgEventArgs';
import {ExcTranslation} from 'exc-core-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {ApplicationService} from '../../services/application.service';
import {EnumerationService} from '../../services/enumeration.service';
import {ExgModalService} from 'exc-controls-v2';
import {ExcRestService} from 'exc-rest-v2';

@Component({
  selector: 'app-tab-task-formular',
  templateUrl: './tab-task-formular.component.html',
  styles: [
  ]
})
export class TabTaskFormularComponent extends ExcTranslation implements OnInit {
  @Input()
  formularVersion: any;
  @Input()
  tableDrawerIsLoading: any | undefined;
  @Input()
  Events: ExgEventArgs | any;

  constructor(
    private excSecurity: ExcSecurityService,
    private appSvc: ApplicationService,
    private modalSvc: ExgModalService,
    private excRestService: ExcRestService,
    public enumSvc: EnumerationService
  ) {
    super();
  }

  ngOnInit(): void {
  }

  onClickOpenFormularVersion(form: any): void {
    if (this.excSecurity.isFeatured('FORMVREAD')) {
      this.appSvc.Formular.Version.OpenTab({frmVID: form.frmVID, frmVName: form.frmVName, fkID: form.frmV_FKID}, {Events: this.Events});
    }
  }

  openModalFormularVersion(event: any, form: any): void {
    event.preventDefault();
    event.stopPropagation();

    if (this.excSecurity.isFeatured('FORMVCREATE')) {
      Object.assign(form, {isNew: false});

      this.modalSvc.show('ModalFormularVersionComponent', form)
        .subscribe((rtVal: any) => {
          if (rtVal) {
            if (rtVal?.del) {
              this.deleteFormularVersion(form);
            } else {
              if (rtVal && rtVal.frmVID) {
                const dataObject = {
                  frmVName: rtVal.frmVName,
                  frmVDescription: rtVal.frmVDescription,
                  frmV_enmIdent_FormularVersionStatus: rtVal.frmV_enmIdent_FormularVersionStatus,
                  frmVUPT: rtVal.frmVUPT,
                };

                this.excRestService
                  .put(this.excRestService.computeUrl('FormularVersionU', {
                    frmVID: form.frmVID
                  }), dataObject)
                  .subscribe((ret: any) => {
                    if (ret.success) {
                      this.modalSvc
                        .showToast('Formular gespeichert',
                          'md-toast bg-green',
                          'far fa-check');
                    }
                  });
              }
            }
          }
        });
    }
  }

  deleteFormularVersionClick(event: any, form: any): void {
    event.preventDefault();
    event.stopPropagation();

    if (this.excSecurity.isFeatured('FORMVDELETE')) {
      this.modalSvc.showSimple(
        'Formular löschen',
        'Möchten Sie das Formular "' + form.frmVName + '" löschen?',
          true,
          true,
          this.getGlobal('Delete'),
          this.getGlobal('Cancel'),
      ).subscribe((rtVal: any) => {
        if (rtVal) {
          this.deleteFormularVersion(form);
        }
      });
    }
  }

  deleteFormularVersion(form: any): void {
    if (this.excSecurity.isFeatured('FORMVDELETE')) {

      this.excRestService
        .delete(
          this.excRestService.computeUrl('FormularVersionD', {
            frmVID: form.frmVID,
          }), {
            frmVUPT: form.frmVUPT
          }
        )
        .subscribe((ret: any) => {
          if (ret.success) {
            this.modalSvc
              .showToast('Formular gelöscht'
                , 'md-toast bg-green'
                , 'far fa-check');
            this.Events?.Formular?.Version?.Closed?.emit();
          }
        });
    }
  }
}
